import { Flex, Grid } from 'antd';
import topBannerImg from 'assets/img/top_banner.gif';

const { useBreakpoint } = Grid;

const BANNER_URL =
    'https://www.rustore.ru/catalog/app/com.profootball.profootball?_rsc=Bl87od1bNOqMZDgt';

const TopBanner = () => {
    const screens = useBreakpoint();

    return (
        <Flex
            className="top-banner"
            align="center"
            justify="center"
            style={{ padding: screens.md ? 10 : '2px 8px 8px 8px' }}
        >
            <a
                href={BANNER_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: 'block', width: '100%', maxWidth: 1080 }}
            >
                <img
                    src={topBannerImg}
                    alt="InScore"
                    style={{ display: 'block', width: '100%', height: 'auto' }}
                />
            </a>
        </Flex>
    );
};

export default TopBanner;
